<template>
    <v-card
      elevation="1"
      class="pa-6 mt-6"
    >
      <div>
        <h4 class="mb-4 d-flex justify-space-between align-center">
          Brands ({{ selectedBrands.length }})
          <v-btn
            v-if="selectedBrands.length && checkProduct"
            icon
            text
            v-track="'show-hide-brand-list-drawer'"
            @click="toggleDrawer()"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </h4>
        <v-skeleton-loader
          v-if="brandLoader"
          type="list-item-three-line, action"
        />
        <div v-else>
          <div v-if="selectedBrands.length">
            <v-chip
              v-for="list in selectedBrands.slice(
                0,
                showAllTags? selectedBrands.length : 3
              )"
              :key="list.id"
              class="my-1 mr-4 "
              color="#cce1ef"
            >
              {{ list.name }}
            </v-chip>
            <v-btn
              v-if="selectedBrands.length > 3"
              text
              @click="showAllTags = !showAllTags"
              v-track="'show-hide-all-tags'"
            >
              VIEW {{ showAllTags ? "LESS" : "ALL" }}
            </v-btn>
          </div>
          <div
            v-if="!selectedBrands.length"
            style="min-height: 81.9px;"
            class="d-flex flex-column "
          >
            <v-label>No Brands to show.</v-label>
            <v-label>Add the customer to a Branded List to send emails.</v-label>
          </div>
        </div>
      </div>
    </v-card>
</template>
<script>
  import { $marketingContacts } from "@core/services"
  export default {
    props: {
      contactId: [Number, String],
      contact: {
        type: String,
      },
    },
    data () {
      return {
        selectedBrands:[],
        brandLoader: false,
        showAllTags:false,
        drawer: false,
      }
    },
    computed:{
      checkProduct(){
       return process.env.VUE_APP_PRODUCT != 'Service'
      }
    },
    watch: {
      '$store.state.ui.drawer.right.response': function () {
        if (this.$store.getters['ui/drawer'].right.response.BrandsList) {
          this.selectedBrands = this.$store.getters['ui/drawer'].right.response.BrandsList
        }
      },
      contact(value){
        if(value)
          this.getSelectedBrands()
      }
    },
    methods: {
      getSelectedBrands () {
        this.brandLoader = true
        const payload = {
          params: {
            'contact[email]': this.contact
          }
        }
        $marketingContacts.getSubscribedBrands(this.contactId,payload).then(response => {
          this.selectedBrands = response.data.data.subscribed_brands
          this.brandLoader = false
        })
      },
      toggleDrawer () {
        this.$store.state.ui.drawer.right.component = 'brands-list-drawer'
        // this.BrandsList = JSON.parse(JSON.stringify(this.BrandsList))
        this.$store.state.ui.drawer.right.show = true
        this.drawer = !this.drawer
      }, 
    },
  }
</script>
